<template>
    <div id="steps-progress">
        <div class="step-icon" @click="setStep(1)">
			<svg viewBox="6.767000198364258 4.343999862670898 25.32900047302246 25.329999923706055" width="25.32900047302246" height="25.329999923706055" xmlns="http://www.w3.org/2000/svg">
				<g transform="matrix(1, 0, 0, 1, 0, 4.440892098500626e-16)">
					<g>
						<g>
							<g>
								<path :fill="colors[0]" d="M19.432,4.344c-6.994,0-12.665,5.67-12.665,12.665s5.67,12.665,12.665,12.665
								s12.664-5.671,12.664-12.665S26.426,4.344,19.432,4.344z M20.223,14.634c0.437,0,0.792,0.354,0.792,0.792
								s-0.354,0.792-0.792,0.792h-3.891c-0.037,0.258-0.066,0.521-0.066,0.792s0.03,0.533,0.066,0.792h3.1
								c0.437,0,0.792,0.354,0.792,0.791s-0.354,0.791-0.792,0.791h-2.615c0.686,1.412,1.949,2.375,3.407,2.375
								c0.691,0,1.339-0.204,1.929-0.605c0.359-0.244,0.854-0.154,1.1,0.207c0.245,0.361,0.153,0.854-0.209,1.1
								c-0.846,0.576-1.82,0.883-2.82,0.883c-2.319,0-4.304-1.643-5.129-3.959h-1.204c-0.437,0-0.791-0.354-0.791-0.791
								s0.354-0.791,0.791-0.791h0.861c-0.028-0.264-0.069-0.521-0.069-0.792s0.041-0.529,0.069-0.792h-0.861
								c-0.437,0-0.791-0.354-0.791-0.792s0.354-0.792,0.791-0.792h1.204c0.825-2.316,2.81-3.958,5.129-3.958
								c1,0,1.974,0.306,2.82,0.882c0.362,0.247,0.454,0.739,0.209,1.1c-0.246,0.364-0.741,0.453-1.1,0.207
								c-0.59-0.402-1.238-0.606-1.929-0.606c-1.458,0-2.721,0.962-3.407,2.375H20.223z"/>

							</g>
						</g>
					</g>
				</g>
			</svg>
		</div>
		<hr :style="'color:'+colors[1]+';background:'+colors[1]">
        <div class="step-icon" @click="setStep(2)">
			<svg version="1.1" id="Layer_1" x="0px" y="0px" width="41.438px" height="33.688px" viewBox="6.760000228881836 4.209000110626221 25.422000885009766 25.42099952697754" enable-background="new 0 0 41.438 33.688" xmlns="http://www.w3.org/2000/svg">
				<g>
					<g>
						<g>
							<path :fill="colors[1]" d="M19.471,4.209C12.45,4.209,6.76,9.9,6.76,16.918c0,7.021,5.69,12.712,12.711,12.712
							c7.02,0,12.711-5.69,12.711-12.712C32.182,9.9,26.49,4.209,19.471,4.209z M19.51,22.917L19.51,22.917h-0.078h-5.43
							c0-3.972,3.487-3.972,4.261-5.008l0.088-0.475c-1.087-0.551-1.854-1.879-1.854-3.432c0-2.047,1.332-3.708,2.974-3.708
							c1.643,0,2.974,1.661,2.974,3.708c0,1.54-0.755,2.86-1.827,3.419l0.1,0.539c0.851,0.987,4.221,1.052,4.221,4.956H19.51z"/>
						</g>
					</g>
				</g>
			</svg>
        </div>
		<hr :style="'color:'+colors[2]+';background:'+colors[2]">
        <div class="step-icon" @click="setStep(3)">
			<svg version="1.1" id="Layer_1" x="0px" y="0px" width="41.438px" height="33.688px" viewBox="6.760000228881836 4.209000110626221 25.422000885009766 25.42099952697754" enable-background="new 0 0 41.438 33.688" xmlns="http://www.w3.org/2000/svg">
				<g>
					<g>
						<g>
							<path fill="#D2D2D3" d="M19.471,4.209C12.45,4.209,6.76,9.9,6.76,16.918c0,7.021,5.69,12.712,12.711,12.712
							c7.02,0,12.711-5.69,12.711-12.712C32.182,9.9,26.49,4.209,19.471,4.209z M19.51,22.917L19.51,22.917h-0.078h-5.43
							c0-3.972,3.487-3.972,4.261-5.008l0.088-0.475c-1.087-0.551-1.854-1.879-1.854-3.432c0-2.047,1.332-3.708,2.974-3.708
							c1.643,0,2.974,1.661,2.974,3.708c0,1.54-0.755,2.86-1.827,3.419l0.1,0.539c0.851,0.987,4.221,1.052,4.221,4.956H19.51z"/>
						</g>
					</g>
				</g>
				<g>
					<circle :fill="colors[2]" cx="19.509" cy="16.916" r="12.655"/>
					<g>
						<g>
							<path fill="#F2F1ED" d="M22.233,13.898c0.046-0.13,0.083-0.26,0.105-0.39c0.407-2.451-0.798-2.536-0.798-2.536
							s-0.2-0.385-0.728-0.677c-0.353-0.209-0.845-0.371-1.494-0.317c-0.209,0.011-0.407,0.051-0.594,0.113
							c-0.238,0.08-0.456,0.198-0.654,0.334c-0.243,0.153-0.472,0.343-0.673,0.558c-0.32,0.325-0.605,0.75-0.728,1.276
							c-0.104,0.394-0.079,0.804,0.006,1.249c0.023,0.13,0.057,0.257,0.105,0.39c-0.24-0.022-0.526,0.117-0.257,1.064
							c0.192,0.693,0.374,0.886,0.512,0.897c0.128,0.823,0.762,1.87,1.806,2.238c0.428,0.15,0.897,0.15,1.325-0.003
							c1.027-0.371,1.685-1.415,1.811-2.235c0.14-0.012,0.32-0.207,0.516-0.897C22.76,14.015,22.477,13.876,22.233,13.898z"/>
						</g>
					</g>
					<g>
						<g>
							<path fill="#F2F1ED" d="M24.253,19.078c-1.469-0.374-2.663-1.214-2.663-1.214l-0.931,2.945l-0.176,0.555l-0.002-0.009
							l-0.153,0.471l-0.493-1.396c1.208-1.688-0.244-1.671-0.326-1.668c-0.082-0.003-1.535-0.02-0.325,1.668l-0.493,1.396l-0.153-0.471
							l-0.002,0.009L18.36,20.81l-0.931-2.945c0,0-1.194,0.84-2.663,1.214c-1.095,0.276-1.149,1.543-1.104,2.171
							c-0.005,0,0.06,0.849,0.122,1.222c0,0,2.14,1.391,5.723,1.394c3.582,0,5.722-1.394,5.722-1.394
							c0.065-0.373,0.128-1.222,0.128-1.222C25.401,20.624,25.349,19.357,24.253,19.078z"/>
						</g>
					</g>
				</g>
			</svg>
        </div>
		<hr :style="'color:'+colors[3]+';background:'+colors[3]">
        <div class="step-icon" @click="setStep(4)">
			<svg version="1.1" id="Layer_1" x="0px" y="0px" width="41.438px" height="33.688px" viewBox="6.760000228881836 4.209000110626221 25.523000717163086 25.548999786376953" enable-background="new 0 0 41.438 33.688" xmlns="http://www.w3.org/2000/svg">
				<g>
					<g>
						<g>
							<path fill="#D2D2D3" d="M19.471,4.209C12.45,4.209,6.76,9.9,6.76,16.918c0,7.021,5.69,12.712,12.711,12.712
							c7.02,0,12.711-5.69,12.711-12.712C32.182,9.9,26.49,4.209,19.471,4.209z M19.51,22.917L19.51,22.917h-0.078h-5.43
							c0-3.972,3.487-3.972,4.261-5.008l0.088-0.475c-1.087-0.551-1.854-1.879-1.854-3.432c0-2.047,1.332-3.708,2.974-3.708
							c1.643,0,2.974,1.661,2.974,3.708c0,1.54-0.755,2.86-1.827,3.419l0.1,0.539c0.851,0.987,4.221,1.052,4.221,4.956H19.51z"/>
						</g>
					</g>
				</g>
				<g>
					<circle :fill="colors[3]" cx="19.534" cy="17.009" r="12.749"/>
					<g>
						<g>
							<g>
								<g>
									<path fill="#F1F0EB" d="M26.149,16.485l-6.269-5.435c-0.158-0.136-0.391-0.136-0.549,0l-2.234,1.937v-0.784
									c0-0.461-0.375-0.836-0.836-0.836s-0.836,0.375-0.836,0.836v2.232l-2.364,2.05c-0.174,0.149-0.193,0.415-0.042,0.589
									c0.152,0.174,0.416,0.194,0.59,0.042l5.995-5.195l5.994,5.195c0.08,0.069,0.179,0.102,0.274,0.102
									c0.118,0,0.232-0.05,0.316-0.144C26.342,16.9,26.321,16.637,26.149,16.485z"/>
									<path fill="#F1F0EB" d="M20.135,14.066c-0.154-0.127-0.342-0.191-0.53-0.191c-0.188,0-0.376,0.064-0.53,0.191l-4.178,3.426
									c-0.194,0.158-0.306,0.396-0.306,0.646v4.095c0,0.461,0.375,0.835,0.836,0.835h2.508V18.89h3.343v4.179h2.509
									c0.46,0,0.835-0.374,0.835-0.835v-4.095c0-0.252-0.112-0.488-0.307-0.646L20.135,14.066z"/>
								</g>
							</g>
						</g>
					</g>
				</g>
			</svg>
        </div>
		<hr :style="'color:'+colors[4]+';background:'+colors[4]">
        <div class="step-icon" @click="setStep(5)">
			<svg version="1.1" id="Layer_1" x="0px" y="0px" width="41.438px" height="33.688px" viewBox="6.723999977111816 4.197000026702881 25.45800018310547 25.433000564575195" enable-background="new 0 0 41.438 33.688" xmlns="http://www.w3.org/2000/svg">
				<g>
					<g>
						<g>
							<path fill="#D2D2D3" d="M19.471,4.209C12.45,4.209,6.76,9.9,6.76,16.918c0,7.021,5.69,12.712,12.711,12.712
							c7.02,0,12.711-5.69,12.711-12.712C32.182,9.9,26.49,4.209,19.471,4.209z M19.51,22.917L19.51,22.917h-0.078h-5.43
							c0-3.972,3.487-3.972,4.261-5.008l0.088-0.475c-1.087-0.551-1.854-1.879-1.854-3.432c0-2.047,1.332-3.708,2.974-3.708
							c1.643,0,2.974,1.661,2.974,3.708c0,1.54-0.755,2.86-1.827,3.419l0.1,0.539c0.851,0.987,4.221,1.052,4.221,4.956H19.51z"/>
						</g>
					</g>
				</g>
				<g>
					<circle :fill="colors[4]" cx="19.411" cy="16.884" r="12.687"/>
					<g>
						<g>
							<path fill="#F1F0EB" d="M25.248,15.146v-1.935c0-0.774-0.63-1.404-1.403-1.404h-8.539c-0.775,0-1.404,0.63-1.404,1.404v7.999
							c0,0.774,0.629,1.404,1.404,1.404h8.539c0.773,0,1.403-0.63,1.403-1.404v-1.937c0.472-0.172,0.811-0.627,0.811-1.159v-1.806
							C26.059,15.774,25.72,15.321,25.248,15.146z M24.522,21.21c0,0.375-0.305,0.679-0.678,0.679h-8.539
							c-0.375,0-0.679-0.304-0.679-0.679v-7.999c0-0.375,0.305-0.679,0.679-0.679h8.539c0.373,0,0.678,0.305,0.678,0.679v1.86h-1.63
							c-1.18,0-2.14,0.96-2.14,2.14c0,1.179,0.96,2.139,2.14,2.139h1.63V21.21z M25.334,18.114c0,0.282-0.229,0.51-0.511,0.51h-1.931
							c-0.781,0-1.414-0.634-1.414-1.413c0-0.78,0.633-1.415,1.414-1.415h1.931c0.281,0,0.511,0.23,0.511,0.512V18.114z"/>
						</g>
					</g>
					<g>
						<g>
							<path fill="#F1F0EB" d="M23.062,16.111c-0.608,0-1.101,0.494-1.101,1.1c0,0.606,0.492,1.1,1.101,1.1c0.605,0,1.1-0.493,1.1-1.1stepdataC24.162,16.605,23.668,16.111,23.062,16.111z M23.062,17.585c-0.208,0-0.377-0.168-0.377-0.374c0-0.207,0.169-0.374,0.377-0.374c0.205,0,0.374,0.167,0.374,0.374C23.437,17.417,23.268,17.585,23.062,17.585z"/>
						</g>
					</g>
				</g>
			</svg>
		</div>
		<hr :style="'color:'+colors[5]+';background:'+colors[5]">
        <div class="step-icon" @click="setStep(6)">
			<svg version="1.1" id="Layer_1" x="0px" y="0px" width="41.438px" height="33.688px" viewBox="6.71999979019165 4.229000091552734 25.4950008392334 25.4950008392334" enable-background="new 0 0 41.438 33.688" xmlns="http://www.w3.org/2000/svg">
				<g>
					<g>
						<g>
							<path :fill="colors[5]" d="M19.468,4.229c-7.029,0-12.748,5.718-12.748,12.748c0,7.029,5.719,12.747,12.748,12.747
							c7.028,0,12.747-5.718,12.747-12.747C32.215,9.948,26.496,4.229,19.468,4.229z M26.574,12.726l-7.845,8.825
							c-0.192,0.218-0.461,0.329-0.734,0.329c-0.214,0-0.43-0.071-0.612-0.215l-4.902-3.922c-0.423-0.338-0.492-0.955-0.154-1.378
							c0.338-0.423,0.957-0.492,1.377-0.154l4.177,3.341l7.227-8.13c0.357-0.404,0.98-0.44,1.384-0.082
							C26.897,11.701,26.934,12.321,26.574,12.726z"/>
						</g>
					</g>
				</g>
			</svg>
        </div>
    </div>
</template>
<script>
export default {
  props: ["colors"],
  methods: {
    setStep(step) {
      this.$emit("goStep", step);
    }
  }
};
</script>
<style scoped lang="scss">
hr {
  width: 100%;
  height: 2px;
}
#steps-progress {
  padding: 4rem 0 1rem;
  padding-left: 1rem;
  display: flex;
  justify-content: center;
  max-width: 45rem;
  margin: auto;
}

.line {
  margin-top: 1.5rem;
  border-top: solid 2px #d0d0d0;
  width: 4rem;
}

.step-icon svg {
  height: 3rem;
  width: 3rem;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Wizard.vue